<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li class="flex items-center ml-4">
            <router-link to="/provisionCommand" class="mr-2 vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("system.label.ViewProvisioningMapping") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("system.label.Edit") }}</vs-button
                    >
                    <vs-button
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      type="border"
                      @click="deleteProvisioningPopup = true"
                      size="small"
                      >{{ $t("system.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("system.label.Id") }}</b>
                </td>
                <td>{{ provisioningDataId.id }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.ProvisioningSystem") }}</b>
                </td>
                <td>{{ provisioningDataId.provisioningSystem }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.CommandName") }}</b>
                </td>
                <td>{{ provisioningDataId.commandName }}</td>
              </tr>
              <tr>
                <td class="border-none">
                  <b>{{ $t("system.label.Status") }}</b>
                </td>
                <td class="border-none">{{ provisioningDataId.status }}</td>
              </tr>
            </table>
          </div>
          <h4 class="mb-5">{{ $t("system.label.CommandParameter") }}</h4>
          <vs-table
            :data="provisioningDataId.commandParameters"
            :description="false"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="thead">
              <vs-th>{{ $t("system.label.ParamName") }}</vs-th>
              <vs-th>{{ $t("system.label.ParamType") }}</vs-th>
              <vs-th>{{ $t("system.label.ParamLength") }}</vs-th>
              <vs-th>{{ $t("system.label.ParamNotes") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="commandParam"
                v-for="(commandParam, index) in data"
              >
                <vs-td :data="commandParam.commandParam">{{
                  commandParam.commandParam
                }}</vs-td>
                <vs-td :data="commandParam.paramType">{{
                  commandParam.paramType
                }}</vs-td>
                <vs-td :data="commandParam.paramLength">{{
                  commandParam.paramLength
                }}</vs-td>
                <vs-td :data="commandParam.paramNotes">{{
                  commandParam.paramNotes
                }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="centerx">
            <vs-popup
              class="popup-close"
              :title="$t('system.label.DeleteProvisionCommand')"
              :active.sync="deleteProvisioningPopup"
            >
              <div class="vx-row centerx md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col sm:w-full w-full">
                  <div class="vx-col sm:w-full w-full">
                    {{ $t("system.label.AreYouSure") }}
                  </div>
                </div>
              </div>

              <div class="vx-row centerx">
                <span class="ml-4 mr-1">
                  <vs-button
                    type="border"
                    @click="deleteProvisioningPopup = false"
                    >{{ $t("system.label.cancel") }}</vs-button
                  >
                </span>
                <span class="ml-1 mr-2">
                  <vs-button
                    @click="deleteProvisionData(delId)"
                    color="warning"
                    >{{ $t("system.label.Ok") }}</vs-button
                  >
                </span>
              </div>
            </vs-popup>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "/config" },
        {
          name: this.$t("system.label.ViewProvisioningMapping"),
          to: "/",
        },
      ],
      provisioningDataId: {},
      deleteProvisioningPopup: false,
    };
  },

  computed: {},
  methods: {
    async dataByIdProvisioning() {
      try {
        const response = await this.$store.dispatch(
          "provisioningConfig/seteditdataByIdProvisioning",
          this.id
        );
        this.provisioningDataId = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editData(id) {
      this.$router.push(`/editCreateCommand/${id}`);
    },
    async deleteProvisionData() {
      try {
        this.deleteProvisioningPopup = false;
        await this.$store.dispatch(
          "provisioningConfig/deleteProvisioningCommand",
          this.id
        );
        this.$router.push(`/provisionCommand`);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY");
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.dataByIdProvisioning();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
